console.log(
  `%c v${SURFSIGHT_VERSION} - ${SURFSIGHT_TIME}`,
  'background: #222; color: red; font-size:12pt;'
)
require('jquery')
require('datejs')
require('angular-material')
require('angular-ui-router')
require('angular-messages')
require('leaflet')
require('leaflet-search')
require('leaflet-draw/dist/leaflet.draw')
require('leaflet-draw/dist/leaflet.draw-src')
require('leaflet-polylinedecorator')
require('leaflet-geometryutil')
require('angular-leaflet-directive')
require('angular-material-icons')
require('angular-jwt')
require('ngstorage')
require('ngclipboard')
require('angular-drag-and-drop-lists')
require('ng-infinite-scroll')
require('angular-translate/dist/angular-translate.min')
require('./directives/dataGrid.min')
require('./directives/pagination.min')
require('./directives/c3-angular')
require('leaflet-toolbar')
require('leaflet-draw-toolbar/dist/leaflet.draw-toolbar')
require('moment')
require('decimal.js')
require('ng-table/bundles/ng-table')
require('./app.modules')
require('./js/helper_functions')
require('./others/leaflet-marker-icon-angle')
require('angular-sanitize')
require('ng-csv')
require('angular-cookies')
require('angular-inview')
import Matercolor from 'matercolors'
import { sanitizePalette } from './js/angular-helpers'
const defaultWhitelabelConfig = require('cloud-utils/config/whitelabel/default.json')
const whiteLabelThemes = require('cloud-utils/config/whitelabel/whilteLabelThemes.json')
  .themes
const { frontendLastModifiedPolling } = require('cloud-utils')
let global$mdThemingProvider = null
const whiteLabelThemeName = 'default'
const whiteLabelPrimaryPalleteName = 'whiteLabelPrimary'
angular
  .module('surfsightApp', [
    'ngAnimate',
    'ui.router',
    'ngMaterial',
    'ngAria',
    'ngMessages',
    'leaflet-directive',
    'ngMdIcons',
    'ngStorage',
    'ngclipboard',
    'dndLists',
    'dataGrid',
    'pagination',
    'surfsightApp.controllers',
    'pascalprecht.translate',
    'gridshore.c3js.chart',
    'infinite-scroll',
    'ngTable',
    'angular-jwt',
    'ngSanitize',
    'ngCsv',
    'ngCookies',
    'angular-inview'
  ])
  .config([
    '$mdThemingProvider',
    '$mdGestureProvider',
    '$translateProvider',
    function ($mdThemingProvider, $mdGestureProvider, $translateProvider) {
      global$mdThemingProvider = $mdThemingProvider
      $mdThemingProvider
        .theme('default')
        .primaryPalette('red')
        .accentPalette('red')
      const datePickerColors = {
        background: [
          '.mddtp-picker__header',
          '.mddtp-picker__grid span.mddtp-picker__cell--selected',
          '.mddtp-button',
          '.mddtp-picker',
          '#mddtp-hour__selected>span',
          '.mddtp-picker__selection span'
        ],
        color: [
          '.mddtp-picker__years .mddtp-picker__li--current',
          '.mddtp-picker__cell',
          '.mddtp-picker__body',
          '.mddtp-picker__body .mddtp-picker__viewHolder .mddtp-picker__grid span.mddtp-picker__cell--today'
        ],
        backgroundAndColor: [
          '.mddtp-picker__body .mddtp-picker__viewHolder .mddtp-picker__grid .mddtp-picker__tr' +
            ' span.mddtp-picker__cell:hover,.mddtp-picker__body .mddtp-picker__viewHolder .mddtp-picker__grid ' +
            'span.mddtp-picker__cell--selected',
          '.mddtp-button',
          '.md-button.md-default-theme.md-primary.md-raised:not([disabled]), .md-button.md-primary.md-raised:not([disabled])'
        ]
      }
      $mdThemingProvider.generateThemesOnDemand(true)
      $mdThemingProvider.registerStyles(`
        .wl-THEME_NAME-theme {
          ${['primary-500', 'background-default-contrast']
            .map(
              colorExpression =>
                `--wl-default-${colorExpression}: {{${colorExpression}}};`
            )
            .join('\n')}
        }
        ${datePickerColors.background
          .map(
            classToChange =>
              `${classToChange}{
            background-color:{{primary-500}} !important;
          }`
          )
          .join('\n')}
       ${datePickerColors.color
         .map(
           classToChange =>
             `${classToChange}{
            color:{{primary-500}} !important;
          }`
         )
         .join('\n')}
       ${datePickerColors.backgroundAndColor
         .map(
           classToChange =>
             `${classToChange}{
            background-color:{{primary-500}} !important;
            color:white !important;
          }`
         )
         .join('\n')}
      `)
      $mdGestureProvider.skipClickHijack()
      $translateProvider.translations('en', require('./languages/en.json5'))
      $translateProvider.translations('fr', require('./languages/fr.json5'))
      $translateProvider.translations('es', require('./languages/es.json5'))
      $translateProvider.translations('it', require('./languages/it.json5'))
      $translateProvider.translations('pt', require('./languages/pt.json5'))
      $translateProvider.translations('de', require('./languages/de.json5'))
      $translateProvider.preferredLanguage('en')
      $translateProvider.useSanitizeValueStrategy('escape')
    }
  ])
  .constant('SystemConstants', {
    unitLabels: ['metric', 'imperial'],
    unit: 0,
    data: {
      km: ['mi', 0.621371],
      'km/h': ['mph', 0.621371],
      'm/s': ['mi/s', 0.277778, 0.000172603109],
      m: ['ft', 2],
      cm: ['in', 4]
    }
  })
  .config([
    '$localStorageProvider',
    function ($localStorageProvider) {
      const prefix = BASE_DOMAIN.replace(/\W/g, '')
      $localStorageProvider.setKeyPrefix(`${prefix}-`)
    }
  ])
  .service('authInterceptor', [
    '$q',
    '$state',
    '$injector',
    '$localStorage',
    function ($q, $state, $injector, $localStorage) {
      this.responseError = function (response) {
        if (
          response.status === 401 &&
          !response.config.url.includes('/validate_authtoken') &&
          !response.config.url.includes('/pin-codes') &&
          new URL(response.config.url).hostname === BASE_DOMAIN // 401 only from our API
        ) {
          // Skip logout if request has Skip-Auth-Logout header
          const skipLogout =
            response.config &&
            response.config.headers &&
            response.config.headers['Skip-Auth-Logout']
          if (!skipLogout) {
            delete $localStorage.userToken
            delete $localStorage.userDetails
            delete $localStorage.userOrganization
            delete $localStorage.selectedOrganization
            delete $localStorage.currentUserOrganization
            delete $localStorage.userMediaAccessToken
            delete $localStorage.isResellerSso
            delete $localStorage.timeFormat
            delete $localStorage.measurementUnits
            if (window.heap) {
              window.heap.resetIdentity()
            }
            const edgeFactory = $injector.get('edgeFactory')
            const edgeFactoryV2 = $injector.get('edgeFactoryV2')
            const edgeGroupFactory = $injector.get('edgeGroupFactory')
            const broadcastViewFactory = $injector.get('broadcastViewFactory')
            edgeFactory.list.splice(0, edgeFactory.list.length)
            edgeFactoryV2.list.splice(0, edgeFactoryV2.list.length)
            edgeGroupFactory.list.splice(0, edgeGroupFactory.list.length)
            broadcastViewFactory.list.splice(
              0,
              broadcastViewFactory.list.length
            )
            setTimeout(function () {
              $state.go('home.login')
            })
          }
        }
        return $q.reject(response)
      }
    }
  ])
  .config([
    '$httpProvider',
    '$cookiesProvider',
    function ($httpProvider, $cookiesProvider) {
      $httpProvider.interceptors.push('authInterceptor')
      $cookiesProvider.defaults.domain = ENV_DOMAIN
    }
  ])
  .run([
    '$rootScope',
    '$filter',
    '$http',
    '$transitions',
    '$mdTheming',
    '$localStorage',
    'UnitSystem',
    'SystemConstants',
    async function (
      $rootScope,
      $filter,
      $http,
      $transitions,
      $mdTheming,
      $localStorage,
      UnitSystem,
      SystemConstants
    ) {
      const $translate = $filter('translate')
      frontendLastModifiedPolling($translate('aNewVersionAvailable'))
      $rootScope.unitSystem = {
        get value () {
          return UnitSystem.value
        },
        get unit () {
          return SystemConstants.unit
        }
      }
      $rootScope.data = {}
      $rootScope.data.whitelabel = {
        whiteLabelThemeName
      }
      $transitions.onSuccess({ to: 'home.common.reports' }, function (
        transition
      ) {
        delete $rootScope.reportDateRangeFilter
      })
      const procedure = whiteLabelConfiguration => {
        if (!whiteLabelConfiguration.whiteLabelThemeName) {
          whiteLabelConfiguration.whiteLabelThemeName = 'red'
        }
        if (!whiteLabelConfiguration.whiteLabelThemeColor) {
          whiteLabelConfiguration.whiteLabelThemeColor = '#f44336'
        }
        $rootScope.data = {}
        $rootScope.data.whitelabel = {
          ...whiteLabelConfiguration,
          whiteLabelThemeName
        }
        document.title = whiteLabelConfiguration.whiteLabelName
        const link = document.createElement('link')
        link.rel = 'icon'
        link.href = whiteLabelConfiguration.whiteLabelFaviconUrl
        const [headElement] = document.getElementsByTagName('head')
        headElement.appendChild(link)
        $localStorage.whiteLabelThemeName = whiteLabelThemeName
        const whiteLabelThemeColorPalette = new Matercolor(
          whiteLabelConfiguration.whiteLabelThemeColor
        )
        global$mdThemingProvider.definePalette(whiteLabelPrimaryPalleteName, {
          ...whiteLabelThemeColorPalette.palette.primary,
          contrastDefaultColor: 'light',
          contrastDarkColors: '50 100 200 300 A100 A200',
          contrastStrongLightColors: '400 500 600 700 800 900 A400 A700'
        })
        angular.forEach($mdTheming.PALETTES, sanitizePalette)
        global$mdThemingProvider
          .theme(whiteLabelThemeName)
          .primaryPalette(whiteLabelPrimaryPalleteName)
          .accentPalette(whiteLabelPrimaryPalleteName)
        $mdTheming.generateTheme(whiteLabelThemeName)
        $rootScope.$emit('whitelabelConfig', {})
        $rootScope.$apply()
      }
      $rootScope.getThemeName = () => {
        return `wl-${whiteLabelThemeName}-theme`
      }
      try {
        const response = await $http.get(
          `${DEVICE_BASEURL}/white-label-information/${window.location.host}`,
          {
            headers: {
              'X-Request-Origin': 'White Label Portal',
              'Content-Type': 'application/json'
            }
          }
        )
        procedure(
          response.data.status.code === 0
            ? response.data.whiteLabelConfiguration
            : defaultWhitelabelConfig
        )
      } catch (ex) {
        procedure(defaultWhitelabelConfig)
      }
    }
  ])
require('./app.routes')
require('./controllers')
require('./services')
require('./directives')
